import { __decorate } from "tslib";
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import FormValidationsMixin from '@/helpers/vue_mixins/v2/FormValidationsMixin';
import ImageUploadMixin from '@/helpers/vue_mixins/v2/ImageUploadMixin';
import FormMixin from '@/helpers/vue_mixins/FormMixin';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import BaseTextArea from '@/components/v2/BaseTextArea';
import WindowSizeListener from '@/helpers/vue_mixins/v3/WindowSizeListenerMixin';
import { Getter, Mutation } from 'vuex-class';
import { required, maxLength, requiredIf } from 'vuelidate/lib/validators';
import ActionButton from '@/components/action_button/Index.vue';
import Uploader from '@/components/v2/Uploader';
import BaseTextField from '@/components/v2/BaseTextField.vue';
import BaseImagePlaceholder from '@/components/v2/BaseImagePlacelholder';
import LinkButton from '@/components/link_button/Index.vue';
import AffiliateProductDialog from '@/components/v2/AffiliateProductDialog.vue';
import BaseCloseBtn from '@/components/v2/BaseCloseBtn';
import AutomaticDiscounts from '@/plugins/graphql/queries/v2/automatic-discounts.gql';
import ActiveFacebookPage from '@/plugins/graphql/queries/active-facebook-page.gql';
import CreateNewAd from '@/plugins/graphql/mutations/ads_manager/create-ad.gql';
import { requiredProperty } from '@/helpers/mixins/LocalizationHelper';
import ConfirmationDialog from '@/components/ConfirmationDialog.vue';
import ToggleConfirmationDialog from '@/components/v2/ToggleConfirmationDialog.vue';
import { Bundle } from '@/helpers/entities/enums/v2/Bundle';
import { ECOMMERCE_B2C, SHOPIFY } from '@/helpers/constants/Bundles';
let CreateAd = class CreateAd extends Mixins(ViewportSizeMixin, RouterParamsAppMixin, WindowSizeListener, FormValidationsMixin, Mixins(FormMixin, ImageUploadMixin, AlertMixin)) {
    constructor() {
        super(...arguments);
        this.defaultPhoto = require('@/assets/images/cg_logo.png');
        this.adAccounts = [];
        this.form = {
            // image: [] as FileUploadInputImpl[],
            image: [],
            name: '',
            adDescription: 'This is a Sample Caption',
            customerAction: 'payload',
            quickReplies: ['How to order?'],
            headline: 'This is a sample headline',
            subDescription: '',
            triggerButton: null,
            messengerMessage: `Discover our top products! Tap 'Shop Now' to browse and find your perfect pick!`,
            messengerImage: [],
            buttonTitle: '',
            invitationTitle: 'Updates and promotions',
            buttonAction: 0,
            discount: null,
            products: [],
        };
        this.automaticDiscounts = [];
        this.fileExceeded = false;
        this.hasRejectedFiles = false;
        this.showButtonOptions = false;
        this.createConfirmModal = false;
        this.selectedTab = 'Design Advert';
        this.sending = false;
        this.discountDummyData = [
            { value: 1, text: 'Discount 1' },
            { value: 2, text: 'Discount 2' },
            { value: 3, text: 'Discount 3' },
        ];
        this.messengerIcon = require('@/assets/images/messenger-logo.svg');
        this.toggleProducts = false;
        this.selectedProducts = [];
    }
    get isB2cBundle() {
        return (this.$route.params.key === Bundle.Ecommerce || this.$props?.serviceBundle === ECOMMERCE_B2C);
    }
    get isShopifyBundle() {
        return this.$route.params.key === Bundle.Shopify || this.$props?.serviceBundle === SHOPIFY;
    }
    get isInsuranceBundle() {
        return this.$route.params.key === Bundle.Insurance;
    }
    get buttonTypeDescription() {
        if (this.form.customerAction === 'payload') {
            return 'Allows users to take action by directing them to an external destination, such as a website, through clickable buttons.';
        }
        return 'Displays short response options that users can tap to quickly engage with your business. Multiple quick replies appear side by side.';
    }
    get queryVariables() {
        return {
            appUuid: this.appUUID,
        };
    }
    removeQuickReply(index) {
        if (this.form.quickReplies.length === 1) {
            this.errorNotification('You must at least have 1 quick reply');
        }
        else {
            this.form.quickReplies.splice(index, 1);
        }
    }
    changeTab(tab) {
        this.selectedTab = tab;
    }
    tabBuilder() {
        const commonProps = {
            orangeTheme: true,
            flat: true,
            capitalized: true,
        };
        return [
            {
                ...commonProps,
                id: 'designAdvert',
                label: 'Design Advert',
            },
            {
                ...commonProps,
                id: 'createAdMessaging',
                label: 'Create Ad Messaging',
            },
        ];
    }
    checkSelectedTab(label) {
        if (this.selectedTab === label) {
            return true;
        }
        return false;
    }
    toggleConfirmation() {
        // this.selectedNotification = uuid;
        // this.$emit('selectDeleteUuid');
        this.showConfirmationDialog();
    }
    uponConfirm() {
        this.hideConfirmationDialog();
        this.$router.push({ name: 'ads-manager' });
    }
    checkRejectedFiles() {
        const self = this;
        this.hasRejectedFiles = !!self.$refs.uploader.getRejectedFiles().length;
    }
    checkMessengerRejectedFiles() {
        const self = this;
        this.hasRejectedFiles = !!self.$refs.messengerUploader.getRejectedFiles().length;
    }
    fileExceed() {
        this.fileExceeded = true;
        this.checkRejectedFiles();
        this.errorNotification('Exceeded total Number of files');
    }
    fileMessengerExceed() {
        this.fileExceeded = true;
        this.checkMessengerRejectedFiles();
        this.errorNotification('Exceeded total Number of files');
    }
    toggleMobilePreview() {
        this.$emit('toggleMobilePreview');
    }
    async proceedToNext() {
        this.sending = true;
        const mutation = () => this.createAd();
        await mutation()
            .then(async ({ data }) => {
            this.sending = false;
            this.successNotification('Ad Successfully created');
            this.$router.push({ name: 'ads-manager' });
        })
            .catch((e) => {
            // this.errorNotification(e.message);
            this.sending = false;
        });
    }
    get buttonActions() {
        if (!this.isInsuranceBundle) {
            return [
                { value: 1, text: 'Offer Discounts' },
                { value: 2, text: 'See Latest Offers' },
                { value: 3, text: 'Subscribe to get the latest offers' },
            ];
        }
        return [
            // { value: 1, text: 'Offer Discounts' },
            { value: 2, text: 'See Latest Offers' },
            { value: 3, text: 'Subscribe to get the latest offers' },
        ];
    }
    get customerActions() {
        if (this.adSetGoal === 'CONVERSATIONS') {
            return [
                { value: 'text', text: 'Quick Replies' },
                { value: 'payload', text: 'Button Payload' },
            ];
        }
        return [{ value: 'payload', text: 'Button Payload' }];
    }
    get checkImageUnshow() {
        if (this.form.image.length) {
            const imageStates = this.form.image.map((image) => image.state);
            if (imageStates.every((state) => state === 'deleted')) {
                return false;
            }
            return true;
        }
        return false;
    }
    get checkMessengerImageUnshow() {
        if (this.form.messengerImage.length) {
            const imageStates = this.form.messengerImage.map((image) => image.state);
            if (imageStates.every((state) => state === 'deleted')) {
                return false;
            }
            return true;
        }
        return false;
    }
    get checkMessengerImageForm() {
        if (this.form.messengerImage.length) {
            return false;
        }
        return true;
    }
    hideButtonActions() {
        this.form.buttonAction = 0;
        this.showButtonOptions = false;
    }
    removeProduct(productToRemove) {
        const index = this.selectedProducts.findIndex((product) => product.uuid === productToRemove.uuid);
        if (index !== -1) {
            this.selectedProducts.splice(index, 1);
        }
    }
    get bundleType() {
        return this.bundleKey;
    }
    openProducts() {
        this.toggleProducts = true;
    }
    closeProducts() {
        this.toggleProducts = false;
    }
    selectProducts(products) {
        this.selectedProducts = products;
    }
    onSelectedProductsChange() {
        // Map through selectedProducts to extract uuid and name
        this.form.products = this.selectedProducts.map((product) => {
            return product.id;
        });
    }
    onAdSetGoalChange() {
        if (this.adSetGoal === 'OFFSITE_CONVERSIONS') {
            this.form.customerAction = 'payload';
        }
        if (this.adSetGoal === 'CONVERSATIONS') {
            this.form.customerAction = 'text';
        }
    }
    onReplyChange() {
        const vm = this;
        vm.$v.form.quickReplies.$touch();
    }
    getImage(img) {
        return img?.galleryBlob.originalUrl;
    }
    changeForm(event) {
        if (event === 0) {
            this.selectedProducts = [];
            //   empty event 3
        }
        if (event === 1) {
            this.selectedProducts = [];
            //   empty event 3
        }
        if (event === 2) {
            this.form.discount = null;
            //   empty event 3
        }
        if (event === 3) {
            this.selectedProducts = [];
            this.form.discount = null;
        }
    }
    get imageErrors() {
        const errors = [];
        // Ensure the validation object is dirty (i.e., has been interacted with)
        if (!this.$v.form.image?.$dirty) {
            return errors;
        }
        // Check if the required validation has failed
        if (!this.$v.form.image?.required) {
            const msg = requiredProperty('Image');
            errors.push(msg);
        }
        return errors;
    }
    replyErrors(v) {
        const errors = [];
        if (!v.$dirty) {
            return errors;
        }
        if (v.$model === '') {
            const msg = 'Quick Reply cannot be empty';
            errors.push(msg);
        }
        if (v.$model.length > 80) {
            const msg = 'Quick Reply Text should not exceed 80 characters';
            errors.push(msg);
        }
        return errors;
    }
    addQuickReply() {
        const vm = this;
        vm.form.quickReplies.push('');
    }
    checkForm() {
        this.$v.$touch();
        if (!this.$v.$invalid) {
            this.createConfirmModal = true;
        }
    }
    async createAd() {
        const vm = this;
        const images = vm.form.image;
        const inputImages = images.map((input) => input.file);
        const variables = {
            input: {
                appUuid: vm.appUUID,
                adAccountId: vm.adAccountId,
                adSetId: vm.adSetId,
                adName: vm.form.name,
                image: inputImages,
                adDescription: vm.form.adDescription,
                headline: vm.form.headline,
                messageText: vm.form.messengerMessage,
                buttonAction: vm.form.buttonAction,
                buttonTitle: vm.form.buttonTitle,
                invitationTitle: vm.form.invitationTitle,
                productIds: vm.form.products,
                discountId: vm.form.discount,
                customerAction: vm.form.customerAction,
                quickReplies: vm.form.quickReplies,
            },
        };
        return this.$apollo
            .mutate({
            mutation: CreateNewAd,
            variables,
        })
            .catch((e) => {
            console.error(e.message);
            this.errorNotification(e.message);
        });
    }
};
__decorate([
    Mutation('showConfirmationDialog')
], CreateAd.prototype, "showConfirmationDialog", void 0);
__decorate([
    Mutation('hideConfirmationDialog')
], CreateAd.prototype, "hideConfirmationDialog", void 0);
__decorate([
    Getter('adAccountId')
], CreateAd.prototype, "adAccountId", void 0);
__decorate([
    Getter('adSetId')
], CreateAd.prototype, "adSetId", void 0);
__decorate([
    Getter('adSetGoal')
], CreateAd.prototype, "adSetGoal", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], CreateAd.prototype, "showMobilePreview", void 0);
__decorate([
    Watch('selectedProducts')
], CreateAd.prototype, "onSelectedProductsChange", null);
__decorate([
    Watch('adSetGoal')
], CreateAd.prototype, "onAdSetGoalChange", null);
__decorate([
    Watch('form.quickReplies', { deep: true })
], CreateAd.prototype, "onReplyChange", null);
CreateAd = __decorate([
    Component({
        components: {
            ActionButton,
            Uploader,
            BaseTextField,
            BaseImagePlaceholder,
            LinkButton,
            AffiliateProductDialog,
            BaseCloseBtn,
            BaseTextArea,
            ConfirmationDialog,
            ToggleConfirmationDialog,
        },
        validations() {
            const vm = this;
            const textOnly = () => vm.form.customerAction === 'text';
            const payload = () => vm.form.customerAction === 'payload';
            const withButtons = () => vm.showButtonOptions;
            const withDiscount = () => vm.form.buttonAction === 1;
            const withProducts = () => vm.form.buttonAction === 2;
            const withInvitation = () => vm.form.buttonAction === 3;
            const validations = {
                form: {
                    image: {
                        required,
                    },
                    name: {
                        required,
                    },
                    adDescription: {
                        required,
                    },
                    headline: {
                        required,
                        maxLength: maxLength(255),
                    },
                    // subDescription: {
                    //   required,
                    // },
                    // triggerButton: {
                    //   required,
                    // },
                    messengerMessage: {
                        required,
                        maxLength: maxLength(80),
                    },
                    buttonTitle: {
                        required: requiredIf(withButtons),
                    },
                    buttonAction: {
                        required: requiredIf(withButtons),
                    },
                    customerAction: {
                        required,
                    },
                    quickReplies: {
                        $each: {
                            required: requiredIf(textOnly),
                        },
                    },
                    discount: {
                        required: requiredIf(withButtons && withDiscount),
                    },
                    products: {
                        required: requiredIf(withButtons && withProducts),
                    },
                    invitationTitle: {
                        required: requiredIf(withButtons && withInvitation),
                    },
                },
            };
            return validations;
        },
        apollo: {
            automaticDiscounts: {
                query: AutomaticDiscounts,
                variables() {
                    return this.queryVariables;
                },
                update({ fetchAllAutomaticDiscounts }) {
                    const { edges, pageInfo, totalCount } = fetchAllAutomaticDiscounts;
                    // Map each edge into { value: uuid, text: name }
                    const formattedDiscounts = edges.map((automaticDiscount) => {
                        if (automaticDiscount.node.active &&
                            (!automaticDiscount.node.endAt ||
                                new Date(automaticDiscount.node.endAt) >= new Date())) {
                            return {
                                value: automaticDiscount.node.uuid,
                                text: automaticDiscount.node.name,
                            };
                        }
                        return null;
                    });
                    this.pageInfo = pageInfo;
                    this.totalCount = totalCount;
                    return formattedDiscounts.filter(Boolean);
                },
                fetchPolicy: 'cache-and-network',
            },
            activePage: {
                query: ActiveFacebookPage,
                variables() {
                    return {
                        appUUID: this.appUUID,
                    };
                },
                // Always Fetch Active Page
                fetchPolicy: 'cache-and-network',
                result({ data }) {
                    if (data) {
                        this.$store.commit('setAppActivePage', data.activePage);
                    }
                },
            },
        },
    })
], CreateAd);
export default CreateAd;
